import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.256 12a7.744 7.744 0 0 1 14.39-3.977h-2.46a.628.628 0 0 0 0 1.256h3.684A1.13 1.13 0 0 0 21 8.15V4.465a.628.628 0 1 0-1.256 0v2.947a9 9 0 1 0 1.155 5.937.628.628 0 0 0-1.241-.187A7.744 7.744 0 0 1 4.256 12",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }